import React from "react";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from "./styles";

import SearchBar from "../common/search";
import Table from "../table";
import ReactTable from "react-table";
import RowLink from "../table/cells/rowlink";
import Title from "../ui/title";
import Content from "../ui/content";

import withRole from "../hoc/role";
import {
  ROLES_CLIENT,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from "../../common/constants";

import {
  iPvTargets,
  nwTestData,
  transTestData,
  wireTestData,
  poeTestData,
  fiberTestData,
  cableTestNT3Data,
  fiberTestNT3Data,
} from "./subtestenum";

const TestsRowLink = withRole(props => {
  return <RowLink {...props} />;
}, ROLES_CLIENT);

class SubTestSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      logoModal: null,
      mode: null,
      contextMenu: false,
      showConfirmDelete: false,
      currentRow: null,
      selected: {},
      selectAll: false,
      filter: false,
      filterable: false,
      showIPTargetsSubItems: false,
      showNetworkTestsSubItems: false,
      showPoeTestsSubItems: false,
      showCableTestsNT3SubItems: false,
      showFiberTestsNT3SubItems: false,
      showCableTestsSTSubItems: false,
      showFiberTestsSTSubItems: false,
      showTransmissionTestsSubItems: false
    };
  }
  view(e, customers) {
    e.preventDefault();
  }

  render() {
    const { translate, languages, classes, impersonating, softwareUpdate } = this.props;
    const { showIPTargetsSubItems, showNetworkTestsSubItems, showPoeTestsSubItems, 
            showCableTestsNT3SubItems, showFiberTestsNT3SubItems, showCableTestsSTSubItems,
            showFiberTestsSTSubItems, showTransmissionTestsSubItems } = this.state;
    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    const columns = [];
    columns.push({
      id: "id",
      accessor: d => d["name"],
      Cell: o => (
        <div style={{ textAlign: "left", paddingLeft: 40 }}>
          {translate(o.original.id)}
        </div>
      )
    });
    columns.push({
      id: "edit",
      Cell: o => {
        return (
          <React.Fragment>
            <div style={{ textAlign: "right", paddingRight: 40 }}>
              <TestsRowLink
                view={this.view}
                link={`/subtestsetting/${o.row.id
                  .replace(/\s/g, "")
                  .replace(/&/g, "")
                  .toLowerCase()}`}
                title={translate("sub_set_edit")}
              />
            </div>
          </React.Fragment>
        );
      },
      display: false
    });
    const rightArrow = "      \u25B6";
    const downArrow  = "      \u25BC";
    const blankHeight = "30px";
    return (
      <div style={{marginTop: margintop}}>
        <Title title={translate("general_sub_test_settings")} />
        <Content translate={translate} isSubTestView="true">
          <div
            style={{
              maxWidth: 600,
              paddingLeft: 120
            }}
          >
            <Typography type="title" onClick={() => this.setState({showIPTargetsSubItems: !showIPTargetsSubItems})}>
              {translate("sub_set_ipv_targets")}{!showIPTargetsSubItems ? rightArrow : downArrow}
            </Typography>
            {showIPTargetsSubItems && <Table
              translate={translate}
              data={iPvTargets}
              columns={columns}
              defaultPageSize={iPvTargets.length}
              showPagination={false}
              style={{
                border: "none",
                position: "relative"
              }}
              noDataText="no_customer_data"
            />}
            {!showIPTargetsSubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showNetworkTestsSubItems: !showNetworkTestsSubItems})}>
              {translate("sub_set_network_tests")}{!showNetworkTestsSubItems ? rightArrow : downArrow}
            </Typography>
            {showNetworkTestsSubItems && <Table
              translate={translate}
              data={nwTestData}
              columns={columns}
              defaultPageSize={nwTestData.length}
              showPagination={false}
              style={{
                border: "none",
                position: "relative"
              }}
              noDataText="no_customer_data"
            />}
            {!showNetworkTestsSubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showPoeTestsSubItems: !showPoeTestsSubItems})}>
              {translate("sub_set_poe_tests")}{!showPoeTestsSubItems ? rightArrow : downArrow}
            </Typography>
            {showPoeTestsSubItems && <Table
              translate={translate}
              data={poeTestData}
              columns={columns}
              defaultPageSize={poeTestData.length}
              showPagination={false}
              style={{
                border: "none"
              }}
              noDataText="no_customer_data"
            />}
            {!showPoeTestsSubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showCableTestsNT3SubItems: !showCableTestsNT3SubItems})}>
              {translate("sub_set_wiremap_nt_tests")}{!showCableTestsNT3SubItems ? rightArrow : downArrow}
            </Typography>
            {showCableTestsNT3SubItems && <Table
              translate={translate}
              data={cableTestNT3Data}
              columns={columns}
              defaultPageSize={cableTestNT3Data.length}
              showPagination={false}
              style={{
                border: "none"
              }}
              noDataText="no_customer_data"
            />}
            {!showCableTestsNT3SubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showFiberTestsNT3SubItems: !showFiberTestsNT3SubItems})}>
              {translate("sub_set_fiber_nt_tests")}{!showFiberTestsNT3SubItems ? rightArrow : downArrow}
            </Typography>
            {showFiberTestsNT3SubItems && <Table
              translate={translate}
              data={fiberTestNT3Data}
              columns={columns}
              defaultPageSize={fiberTestNT3Data.length}
              showPagination={false}
              style={{
                border: "none"
              }}
              noDataText="no_customer_data"
            />}
            {!showFiberTestsNT3SubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showCableTestsSTSubItems: !showCableTestsSTSubItems})}>
              {translate("sub_set_wiremap_st_tests")}{!showCableTestsSTSubItems ? rightArrow : downArrow}
            </Typography>
            {showCableTestsSTSubItems && <Table
              translate={translate}
              data={wireTestData}
              columns={columns}
              defaultPageSize={wireTestData.length}
              showPagination={false}
              style={{
                border: "none"
              }}
              noDataText="no_customer_data"
            />}
            {!showCableTestsSTSubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showFiberTestsSTSubItems: !showFiberTestsSTSubItems})}>
              {translate("sub_set_fiber_st_tests")}{!showFiberTestsSTSubItems ? rightArrow : downArrow}
            </Typography>
            {showFiberTestsSTSubItems && <Table
              translate={translate}
              data={fiberTestData}
              columns={columns}
              defaultPageSize={fiberTestData.length}
              showPagination={false}
              style={{
                border: "none"
              }}
              noDataText="no_customer_data"
            />}
            {!showFiberTestsSTSubItems && <div style={{ height: blankHeight }} />}
            <Typography type="title" onClick={() => this.setState({showTransmissionTestsSubItems: !showTransmissionTestsSubItems})}>
              {translate("sub_set_transmission_tests")}{!showTransmissionTestsSubItems ? rightArrow : downArrow}
            </Typography>
            {showTransmissionTestsSubItems && <Table
              translate={translate}
              data={transTestData}
              columns={columns}
              defaultPageSize={transTestData.length}
              showPagination={false}
              style={{
                border: "none"
              }}
              noDataText="no_customer_data"
            />}
            {!showTransmissionTestsSubItems && <div style={{ height: blankHeight }} />}
          </div>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(SubTestSettings);
